export enum ConsoleType {
	Error = 'error',
	Info = 'info',
	Log = 'log',
	Warning = 'warning',
}

export enum MessageStyle {
	Regular = 'regular',
	Code = 'code',
}
